"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeTypeComplimentaryWithEnum = void 0;
var UpgradeTypeComplimentaryWithEnum;
(function (UpgradeTypeComplimentaryWithEnum) {
    UpgradeTypeComplimentaryWithEnum["Order"] = "Order";
    UpgradeTypeComplimentaryWithEnum["Ticket"] = "Ticket";
})(UpgradeTypeComplimentaryWithEnum = exports.UpgradeTypeComplimentaryWithEnum || (exports.UpgradeTypeComplimentaryWithEnum = {}));
;
//# sourceMappingURL=IEventUpgrade.js.map